import { Box } from "@mui/material";
import { Pagination, useListContext, type PaginationProps } from "react-admin";
import { useScrollToListTop } from "../../hooks/useScrollToListTop";

/**
 * react-admin <Pagination> that brings the list back to its top on a page
 * change. The wrapper is display:contents, so it adds no box of its own; it
 * only gives the hook a DOM node to find the enclosing .RaList-root from.
 */
const ScrollTopPagination = (props: PaginationProps) => {
  const { page } = useListContext();
  const ref = useScrollToListTop(page, { closest: ".RaList-root" });
  return (
    <Box ref={ref} sx={{ display: "contents" }}>
      <Pagination {...props} />
    </Box>
  );
};

export default ScrollTopPagination;
